module.exports = __webpack_public_path__ + "img/info.2d5a834e.svg";